App.prototype.buildSelect = function (data, targetElement) {
    var options = `<option value="">${translates.choose}</option>`;
    data.options.forEach(function (item) {
        options += `<option value="${item.unique_id}">${item.name}</option>`;
    });
    var required = data.is_required ? ' required' : '';
    var is_required = data.is_required ? `<span class="badge badge-danger">${translates.required}</span>` : '';
    var select =
        `<div class="form-group">
            <label class="d-flex align-items-center justify-content-between">
                <h6 class="mb-0">${data.name}</h6>${is_required}
            </label>
            <select name="features[${data.unique_id}]" class="form-control custom-select" ${required}>
                ${options}
            </select>
        </div>`;
    targetElement.append(select);
    targetElement.find('select').trigger('change');
};
